import { IdvDataUpdatedActivity } from "../types";
import { getFullName } from "shared/utils/get-full-name";
import { combinedRoles } from "../constants";

export const IdvDataUpdated = ({
  activityItem
}: {
  activityItem: IdvDataUpdatedActivity;
}) => {
  return (
    <div className="space-y-2">
      <p className="text-base font-bold text-content-1000">
        Identity verification basic info was edited{" "}
        <span className="font-normal">
          {activityItem.details.first_name ? (
            <>
              for{" "}
              {getFullName({
                firstName: activityItem.details.first_name.new || "",
                lastName: activityItem.details.last_name?.new || "",
                middleName: activityItem.details.middle_name?.new || "",
                short: true
              })}
            </>
          ) : (
            <>
              for{" "}
              {activityItem.details.contact?.role
                ? combinedRoles[activityItem.details.contact.role]
                : ""}
            </>
          )}
        </span>
      </p>
      <div>
        <p className="text-sm font-normal text-content-400">
          by {activityItem.author?.name} (
          {activityItem.author?.author_role
            ? combinedRoles[activityItem.author.author_role]
            : "-"}
          )
        </p>
        {Object.entries(activityItem.details).reduce<JSX.Element[]>(
          (acc, [field, change]) => {
            if (
              typeof change !== "object" ||
              !("old" in change) ||
              !("new" in change)
            )
              return acc;
            const { old, new: newValue } = change as {
              old: string;
              new: string;
            };

            // Skip if no actual change, except SSN which is masked when changed
            if (change.old === change.new && field !== "ssn") return acc;

            acc.push(
              field === "ssn" ? (
                <p key={field} className="text-sm font-normal text-content-400">
                  SSN was updated
                </p>
              ) : (
                <p key={field} className="text-sm font-normal text-content-400">
                  Previous {field.replace(/_/g, " ")}: {old || "—"} • New{" "}
                  {field.replace(/_/g, " ")}: {newValue || "—"}
                </p>
              )
            );
            return acc;
          },
          []
        )}
      </div>
    </div>
  );
};
